import { ActivatedRoute } from '@angular/router';

/** Walks the activated-route tree to find the career role :slug param. */
export function resolveCareerRoleSlug(route: ActivatedRoute): string {
  let current: ActivatedRoute | null = route;
  while (current) {
    const slug = current.snapshot.paramMap.get('slug');
    if (slug) {
      return slug;
    }
    current = current.parent;
  }
  return '';
}

/** Route segment that owns the :slug param, if any. */
export function findCareerRoleSlugRoute(route: ActivatedRoute): ActivatedRoute | null {
  let current: ActivatedRoute | null = route;
  while (current) {
    if (current.snapshot.paramMap.has('slug')) {
      return current;
    }
    current = current.parent;
  }
  return null;
}
